import { stripHtml } from "./stringUtils";

const MAX_DESCRIPTION_LEN = 160;
const MAX_KEYWORDS_LEN = 500;

/**
 * Build SEO meta fields for a store listing detail page.
 * - Title: store / business name only (document title)
 * - Description: overview (HTML stripped), truncated for SERP snippets
 * - Keywords: listing “services” — additionalServices + category + subcategory + servicesDetails.service (plain text)
 */
export function buildListingMetaTags(store, options = {}) {
    if (!store || !store.id) return null;

    const name = (store.businessDetails?.businessName || "").trim() || "Listing";

    const rawOverview = store.businessDetails?.description;
    const plainOverview =
        typeof rawOverview === "string" ? stripHtml(rawOverview).replace(/\s+/g, " ").trim() : "";

    let description = plainOverview;
    if (description.length > MAX_DESCRIPTION_LEN) {
        description = `${description.slice(0, MAX_DESCRIPTION_LEN - 1).trimEnd()}…`;
    }
    if (!description) {
        description = name;
    }

    /** Meta keywords: services-oriented terms (per product requirement). */
    const keywordParts = [];

    const additional = Array.isArray(store.additionalServices) ? store.additionalServices : [];
    additional.forEach((item) => {
        if (typeof item === "string" && item.trim()) keywordParts.push(item.trim());
    });

    if (store.category) keywordParts.push(String(store.category).trim());
    if (store.subcategory) keywordParts.push(String(store.subcategory).trim());

    const primaryService = store.servicesDetails?.service;
    if (typeof primaryService === "string" && primaryService.trim()) {
        const line = stripHtml(primaryService).replace(/\s+/g, " ").trim();
        if (line) keywordParts.push(line.slice(0, 200));
    }

    const unique = [...new Set(keywordParts.filter(Boolean))];
    let keywords = unique.join(", ");
    if (keywords.length > MAX_KEYWORDS_LEN) {
        keywords = `${keywords.slice(0, MAX_KEYWORDS_LEN - 1).trimEnd()}…`;
    }

    const title = name;

    const canonicalBase = (options.canonicalOrigin || "").replace(/\/$/, "");
    const canonicalPath = options.canonicalPath || "";
    const canonical = canonicalBase && canonicalPath ? `${canonicalBase}${canonicalPath}` : undefined;

    return {
        title,
        description,
        keywords,
        canonical,
        ogType: "website",
    };
}
